import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/index.js';
import penalties from './penalties';
import { createPageSeoSync } from '@/entities/page-seo';
import cancellation from '@/router/cancellation';
import insuranceProducts from '@/router/insuranceProducts';
import miniKasko from '@/router/miniKasko';
import news from '@/router/news';
import organizations from '@/router/organizations';
import partners from '@/router/partners';
import telegramBot from '@/router/telegram-bot';

Vue.use(VueRouter);

const onlyAgent = (to, from, next) => {
  if (!store.getters.USER.organizationId) {
    next();
  } else {
    next({ name: 'prime' });
  }
};

const routes = [
  {
    path: '/prime',
    name: 'prime',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Головна',
    },
    component: () => import('../pages/home-page'),
  },
  {
    path: '/',
    redirect: '/prime',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
  },
  {
    path: '*',
    redirect: '/prime',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
  },
  {
    path: '/knowledge-base',
    name: 'knowledgeBase',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'База знань'
    },
    component: () => import('../pages/knowledge-base-page'),
  },
  {
    path: '/knowledge-base-articles/:id',
    name: 'knowledgeBaseShow',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'База знань'
    },
    component: () => import('../pages/knowledge-base-page/article.vue'),
  },
  {
    path: '/knowledge-base-categories',
    name: 'knowledgeBaseCategories',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'База знань'
    },
    component: () => import('../pages/knowledge-base-page/categories.vue'),
  },
  {
    path: '/knowledge-base-categories/:id',
    name: 'knowledgeBaseCategoryShow',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true, title: 'База знань'
    },
    component: () => import('../pages/knowledge-base-page/showCategory.vue'),
  },
  {
    path: '/registration',
    name: 'registration',
    meta: {
      layout: 'emptyLayout',
      disableIfLoggedIn: true
    },
    component: () => import('../pages/register-page'),
  },
  {
    path: '/auth/email/verify/:email/:token',
    name: 'setup-password',
    meta: {
      layout: 'emptyLayout',
      disableIfLoggedIn: true
    },
    component: () => import('../pages/setup-password-page')
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    meta: {
      layout: 'emptyLayout',
      disableIfLoggedIn: true
    },
    component: () => import('../pages/forgot-password-page')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      layout: 'emptyLayout',
      disableIfLoggedIn: true
    },
    component: () => import('../pages/login-page'),
  },
  {
    path: '/payment-status',
    name: 'paymentStatus',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: false,
      title: 'Статус оплати'
    },
    component: () => import('../pages/payment-status'),
  },
  {
    path: '/promo',
    name: 'promo',
    meta: {
      layout: 'emptyLayout',
    },
    component: () => import('../pages/promo-page')
  },
  {
    path: '/onboarding-page',
    name: 'onboardingPage',
    meta: {
      layout: 'onboardingLayout',
      requiresAuth: true,
      title: 'База знань'
    },
    component: () => import('../pages/onboarding-page'),
  },
  {
    path: '/insurance-intermediary',
    name: 'insurance-intermediary',
    meta: {
      layout: 'emptyLayout',
    },
    component: () => import('../pages/insurance-intermediary-page'),
  },
  {
    path: '/insurance-companies',
    name: 'insurance-companies',
    meta: {
      layout: 'emptyLayout',
    },
    component: () => import('../pages/insurance-companies-page'),
  },
  {
    path: '/sub-agent',
    name: 'subAgent',
    meta: {
      layout: 'customLayout',
      requiresAuth: false,
      requiresLevel: false,
      title: 'Інформація про субагента'
    },
    component: () => import('../pages/sub-agent-page'),
  },
  {
    path: '/profile',
    name: 'profile',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Профіль'
    },
    component: () => import('../pages/profile-page'),
  },
  {
    path: '/history',
    name: 'history',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Історія замовлень'
    },
    component: () => import('../pages/history-page'),
  },
  {
    path: '/clients',
    name: 'clients',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Клієнти'
    },
    component: () => import('../pages/clients-page'),
  },
  {
    path: '/clients/:clientId',
    name: 'client_info',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Інформація про клієнта'
    },
    component: () => import('../pages/clients-page/clientFullInfo.vue')
  },
  {
    path: '/referral',
    name: 'referrals',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Реферальна програма'
    },
    component: () => import('../pages/referral-page'),
  },
  /*{
    path: '/propositions',
    name: 'propositions',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Сторінки пропозицій'
    },
    component: () => import('../pages/propositions-page'),
  },*/
  {
    path: '/quotations',
    name: 'quotations',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Центр котирування'
    },
    component: () => import('../pages/quotation-page'),
  },
  {
    path: '/quotation-info/:id/info',
    name: 'quotation-info',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Інформація про котировку'
    },
    component: () => import('../pages/quotation-page/quotationInfo.vue')
  },
  {
    path: '/history/:orderId/:typeId/insurance-osago-info',
    name: 'history_insuranceOsagoInfo',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Інформація про замовлення'
    },
    component: () => import('../pages/history-page/osagoInfo.vue')
  },
  {
    path: '/history/:orderId/insurance-green-card-info',
    name: 'history_insuranceGreenCardInfo',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Інформація про замовлення'
    },
    component: () => import('../pages/history-page/greenCardInfo.vue')
  },
  {
    path: '/history/:orderId/insurance-tourism-info',
    name: 'history_insuranceTourismInfo',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Інформація про замовлення'
    },
    component: () => import('../pages/history-page/tourismInfo.vue')
  },
  {
    path: '/history/:orderId/insurance-home-info',
    name: 'history_insuranceHomeInfo',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Інформація про замовлення'
    },
    component: () => import('../pages/history-page/homeInfo.vue')
  },
  {
    path: '/history/:orderId/insurance-pets-info',
    name: 'history_insurancePetsInfo',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Інформація про замовлення'
    },
    component: () => import('../pages/account/history-page/petsInfo.vue')
  },
  {
    path: '/history/:orderId/:typeId/insurance-accident-info',
    name: 'history_insuranceAccidentInfo',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Інформація про замовлення'
    },
    component: () => import('../pages/history-page/accidentInfo.vue')
  },
  {
    path: '/history/:orderId/insurance-accident-info',
    name: 'history_insuranceAccidentInfo_short',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Інформація про замовлення'
    },
    component: () => import('../pages/history-page/accidentInfo.vue')
  },
  {
    path: '/prolongation',
    name: 'prolongation',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Пролонгації'
    },
    component: () => import('../pages/prolongation-page'),
  },
  {
    path: '/password',
    name: 'password',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Паролі'
    },
    component: () => import('../pages/password-page')
  },
  {
    path: '/bonus',
    name: 'bonus',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Партнерська програма'
    },
    component: () => import('../pages/bonus-page')
  },
  {
    path: '/score',
    name: 'score',
    beforeEnter: onlyAgent,
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Мої рахунки',
    },
    component: () => import('../pages/score-page'),
  },
  // {
  //   path: '/products',
  //   name: 'products',
  //   meta: {
  //     layout: 'emptyLayout',
  //     requiresAuth: true,
  //     title: 'Страхові продукти'
  //   },
  //   component: () => import('../pages/products-page'),
  // },
  // {
  //   path: '/products/tariff/add',
  //   name: 'addTariff',
  //   meta: {
  //     layout: 'emptyLayout',
  //     requiresAuth: true,
  //     title: 'Додати тариф'
  //   },
  //   component: () => import('../pages/tariff-page/add.vue')
  // },
  {
    path: '/order-step',
    name: 'orderSteps',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/insurance-osago-page/steps.vue')
  },
  {
    path: '/search',
    name: 'search',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/insurance-osago-page/search.vue')
  },
  {
    path: '/order-final',
    name: 'orderFinal',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/insurance-osago-page/finaly.vue')
  },
  {
    path: '/osago-list',
    name: 'osagoResults',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/insurance-osago-page/results.vue')
  },
  {
    path: '/pets-calculator',
    name: 'petsCalculator',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
    },
    component: () => import('../pages/insurance/pets/insurance-pets-page/calculator.vue')
  },
  {
    path: '/pets-offers',
    name: 'petsOffers',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
    },
    component: () => import('../pages/insurance/pets/insurance-pets-page/offers.vue')
  },
  {
    path: '/pets-policy-details/:orderId?',
    name: 'petsPolicyDetails',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
    },
    component: () => import('../pages/insurance/pets/insurance-pets-page/policy-details.vue')
  },
  {
    path: '/pets-finalization',
    name: 'petsFinalization',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
    },
    component: () => import('../pages/insurance/pets/insurance-pets-page/finalization.vue')
  },
  {
    path: '/auth/password/reset/:email/:token',
    name: 'resetPassword',
    meta: {
      layout: 'emptyLayout',
      disableIfLoggedIn: true
    },
    component: () => import('../pages/change-password-page')
  },
  {
    path: '/bus-search',
    name: 'busSearch',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      requiresBus: true
    },
    component: () => import('../pages/insurance-bus-page/search.vue')
  },
  {
    path: '/bus-list',
    name: 'busResults',
    props: true,
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      requiresBus: true
    },
    component: () => import('../pages/insurance-bus-page/results.vue')
  },
  {
    path: '/bus-steps',
    name: 'busSteps',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      requiresBus: true
    },
    component: () => import('../pages/insurance-bus-page/steps.vue')
  },
  {
    path: '/bus-finnaly',
    name: 'busFinnaly',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      requiresBus: true
    },
    component: () => import('../pages/insurance-bus-page/finaly.vue')
  },
  {
    path: '/greencard-search',
    name: 'greenCard',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/insurance-green-card-page/search.vue')
  },
  {
    path: '/greencard-list',
    name: 'greenCardResults',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/insurance-green-card-page/results.vue')
  },
  {
    path: '/greencard-steps',
    name: 'greenCardSteps',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/insurance-green-card-page/steps.vue')
  },
  {
    path: '/greencard-finnaly',
    name: 'greenCardFinnaly',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/insurance-green-card-page/finaly.vue')
  },
  {
    path: '/tourism-search',
    name: 'tourism-search',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/insurance-tourism-page/search.vue')
  },
  {
    path: '/tourism-result',
    name: 'tourismResult',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/insurance-tourism-page/results.vue')
  },
  {
    path: '/tourism-steps',
    name: 'tourismSteps',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/insurance-tourism-page/steps.vue')
  },
  {
    path: '/tourism-finnaly',
    name: 'tourismFinnaly',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/insurance-tourism-page/finaly.vue')
  },
  {
    path: '/home-search',
    name: 'homeSearch',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/insurance-home-page/search.vue')
  },
  {
    path: '/home-list',
    name: 'homeResults',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/insurance-home-page/results.vue')
  },
  {
    path: '/home-steps',
    name: 'homeSteps',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/insurance-home-page/steps.vue')
  },
  {
    path: '/home-finnaly',
    name: 'homeFinnaly',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/insurance-home-page/finaly.vue')
  },
  {
    path: '/quotation-search',
    name: 'quotation-search',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/insurance-quotation-page/quotation-search.vue')
  },
  {
    path: '/accident-search',
    name: 'accidentSearch',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Нещасний випадок',
    },
    component: () => import('../pages/insurance-accident-page/search.vue')
  },
  {
    path: '/accident-list',
    name: 'accidentList',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Пропозиції - Нещасний випадок',
    },
    component: () => import('../pages/insurance-accident-page/results.vue')
  },
  {
    path: '/accident-steps',
    name: 'accidentSteps',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Оформлення - Нещасний випадок',
    },
    component: () => import('../pages/insurance-accident-page/steps.vue')
  },
  {
    path: '/accident-finally',
    name: 'accidentFinnaly',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Підтвердження - Нещасний випадок',
    },
    component: () => import('../pages/insurance-accident-page/finally.vue')
  },
  {
    path: '/accident-lawyer-form',
    name: 'accidentLawyerForm',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true
    },
    component: () => import('../pages/accident-lawyer-page')
  },
  // {
  //     path: '/bonus-system',
  //     name: 'bonusSystem',
  //     meta: {
  //         layout: 'profileLayout',
  //         requiresAuth: true,
  //         requiresLevel: true,
  //         title: 'Бонусна система'
  //     },
  //     component: () => import('../views/bonusSystem/index.vue')
  // },
  {
    path: '/links/:id',
    name: 'links',
    meta: {
      layout: 'customLayout',
      requiresAuth: false,
      requiresLevel: false,
      title: 'Посилання'
    },
    component: () => import('../views/links/index.vue')
  },
  {
    path: '/reissue-requests',
    name: 'reissue',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Запити на переоформлення'
    },
    component: () => import('../pages/reissue-requests')
  },
  {
    path: '/withdrawal-requests-list',
    name: 'withdrawalRequests',
    meta: {
      layout: 'emptyLayout',
      requiresAuth: true,
      title: 'Запити на виведення коштів'
    },
    component: () => import('../pages/withdrawal-requests-page')
  },
  ...penalties,
  ...cancellation,
  ...partners,
  ...organizations,
  ...insuranceProducts,
  ...miniKasko,
  ...news,
  ...telegramBot,
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  router.app.$lastRoute = from;
  if (to.query.utm_source === 'referral') {
    const utm_source = to.query.utm_source;
    const utm_medium = to.query.utm_medium;
    let utmParams = {
      utm_medium: utm_medium
    };
    utmParams = JSON.stringify(utmParams);
    const expiration = new Date();
    expiration.setDate(expiration.getDate() + 30); // Кукисы будут действовать 30 дней
    document.cookie = 'utm_source=' + escape(utm_source) + ';expires=' + expiration.toUTCString() + ';path=/';
    document.cookie = 'utm_medium=' + escape(utm_medium) + ';expires=' + expiration.toUTCString() + ';path=/';
    document.cookie = 'utm_params=' + escape(utmParams) + ';expires=' + expiration.toUTCString() + ';path=/';
  }


  if (to.meta.requiresAuth) {
    if (store.getters.IS_LOGGED_IN) {
      if (to.meta.requiresBus && store.getters.USER_INFO.busInsurance === false) {
        next({ name: 'prime' });
      } else if (to.meta.requiresLevel && store.getters.USER_INFO.levelId === null) {
        next({ name: 'prime' });
      } else {
        next();
      }
      return;
    }

    next({ name: 'promo' });
  } else if (to.meta.disableIfLoggedIn && store.getters.IS_LOGGED_IN && !to.query.token) {
    next({ name: 'profile' });
  } else if (to.meta.requiresAuth === false) {
    next();
  } else {
    next();
  }

});

const syncPageSeo = createPageSeoSync();

router.afterEach((to, from) => {
  if (!from.name || to.path !== from.path) {
    syncPageSeo(to.path);
  }
});

export default router;
